/*eslint no-unused-vars: ["warn", { "varsIgnorePattern": "[iI]gnored" }]*/

import K from '../constants';
import restHelpers from '../helpers/restHelper';

const getFn = status => restHelpers.withBearer.get(`${K.API_URL}/cars/get-with-all${status ? '?status=' + status : ''}`, {});
const getCarsFn = dealer => restHelpers.withBearer.get(restHelpers.dealersQueryString(`${K.API_URL}/cars?`, dealer), {});
const getListFn = ({ page = 1, size = 10, sort = '', order = '', filters, query }) => restHelpers.withBearer.get(`${K.API_URL}/cars/get-list?_=${new Date().getTime()}&page=${page - 1}&size=${size}${sort !== '' && order !== '' ? `&sort=${sort}&order=${order}` : ''}${filters ? `&${filters}` : ''}${query ? `&q=${query}` : ''}`, {});
const getListBadgesFn = ({ filters, query }) => restHelpers.withBearer.get(`${K.API_URL}/cars/get-list-badges?_=${new Date().getTime()}${filters ? `&${filters}` : ''}${query ? `&q=${query}` : ''}`, {});
const getFiltersOptionsFn = () => restHelpers.withBearer.get(`${K.API_URL}/cars/get-filters-options`, {});
const exportFn = ({ filters, query }) => restHelpers.withBearer.get(`${K.API_URL}/cars/export-all?_=${new Date().getTime()}${filters ? `&${filters}` : ''}${query ? `&q=${query}` : ''}`, {});

export default {
  get: getFn,
  getCars: getCarsFn,
  getList: getListFn,
  getListBadges: getListBadgesFn,
  getFiltersOptions: getFiltersOptionsFn,
  export: exportFn
};
